import { type RouteProp, useRoute } from "@react-navigation/native";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { useApi } from "../../../core/apis";
import { log } from "../../../ui/log";
import type ExpenseModuleModel from "../ExpenseModuleModel";
import { AddExpenseForm } from "./AddExpenseForm/AddExpenseForm";
import { ExpenseModuleContent } from "./ExpenseModuleContent";

export const ExpenseModuleUI = observer(
  ({ module }: { module: ExpenseModuleModel }) => {
    const { modulesDataApi } = useApi();
    const moduleUid = module.uid;

    // biome-ignore lint/suspicious/noExplicitAny: Because
    const { params } = useRoute<RouteProp<any>>();
    const dataUid = params?.dataUid;

    React.useEffect(() => {
      const unsub = modulesDataApi.watchDataForModuleUid(moduleUid);
      return () => {
        log.network(
          `Stopped watchDataForModuleUid from moduleUid ${moduleUid}`,
        );
        unsub();
      };
    }, [modulesDataApi, moduleUid]);

    const expense =
      dataUid !== "new"
        ? module.expenses.find((t) => t.uid === dataUid)
        : undefined;

    return dataUid ? (
      <AddExpenseForm module={module} expense={expense} />
    ) : (
      <ExpenseModuleContent module={module} />
    );
  },
);
